export var ManualActionTypeEnum;
(function (ManualActionTypeEnum) {
    ManualActionTypeEnum["INCREASE"] = "INCREASE";
    ManualActionTypeEnum["DECREASE"] = "DECREASE";
})(ManualActionTypeEnum || (ManualActionTypeEnum = {}));
//# sourceMappingURL=manual-action-type.enum.js.map